angular.module('eficienciaFiscalModule')

    .directive('cbkTabs', ['httpService', 'pathService', function (httpService, pathService) {

        return {
            restrict: 'E',
            replace: true,
            scope: {
                tabs: '=',
                tabController: '=?',
                tabsLeft: '&'
            },
            template: '<div class="{{tabsLeft() ? \'tabs-left\' : \'\'}}">' +
                '   <ul class="nav nav-tabs bordered" style="border-right: 0; border-top: 0; border-left: 0">' +
                '       <li ng-repeat="tab in tabs" ng-if="(tab.if == undefined || tab.if) && (tab.privilege == undefined || tab.privilege) && !tab.hidden" class="{{activeTab == tab.id ? \'active\' : \'\'}}" ng-class="tab.tabClass">' +
                '           <a href="javascript:void(0)" ng-click="selectTab(tab.id)">' +
                '               <i class="fa {{tab.icon}}" ng-if="tab.icon"></i> {{tab.label}}' +
                '               <span ng-if="tab.active && (tab.refresh == undefined || tab.refresh)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>' +
                '               <span ng-if="tab.closable">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>' +
                '           </a>' +
                '           <span ng-if="tab.active && (tab.refresh == undefined || tab.refresh)" ng-click="reloadTab(tab.id)" class="air air-top-right" style="top:9px;" ng-style="{right: tab.closable ? \'32px\' : \'7px\'}"><button class="btn btn-xs font-xs btn-default hover-transparent"><i class="fa fa-refresh"></i></button></span>' +
                '           <span ng-if="tab.closable" ng-click="closeTab(tab.id)" class="air air-top-right" style="top:9px; right:7px;"><button class="btn btn-xs font-xs btn-default hover-transparent"><i class="fa fa-times"></i></button></span>' +
                '       </li>' +
                '   </ul>' +
                '   <div class="tab-content" style="padding: 13px;">' +
                '       <cbk-tabs-pane ng-repeat="tab in tabs" tab-obj="tab"></cbk-tabs-pane>' +
                '   </div>' +
                '</div>',
            controller: ['$scope', function ($scope) {
                var ctrl = this;

                this.addTab = function (tabObj, stayInTab) {
                    var exists = false;
                    angular.forEach($scope.tabs, function (tab) {
                        if (tab.id == tabObj.id)
                            exists = true;
                    });

                    if (!exists)
                        $scope.tabs.push(tabObj);
                    else
                        this.updateTab(tabObj.id, tabObj);

                    stayInTab = stayInTab || false;

                    if (!stayInTab)
                        this.selectTab(tabObj.id)
                };

                this.activeTabs = function () {
                    return $scope.tabs.select(function (tab) {
                        return (tab.if == undefined || tab.if) && (tab.privilege == undefined || tab.privilege);
                    })
                };

                this.closeAll = function () {
                    var tabs = $scope.tabs;

                    angular.forEach(tabs, function (tab) {
                        if (tab.closable)
                            ctrl.closeTab(tab.id);
                    })
                };

                this.selectTab = function (id) {
                    $scope.activeTab = id;
                };

                this.closeTab = function (id, nextTab) {
                    id = id || $scope.activeTab;

                    //Verifica se só existe uma tab.
                    var tabsLength = ctrl.activeTabs().length;

                    if (tabsLength == 1) return;

                    //Verifica qual será a próxima tab caso remova a ativa e não tenha definido a próxima.
                    if ($scope.activeTab == id && nextTab == undefined) {
                        angular.forEach($scope.tabs, function (tab, key) {
                            if (tab.id == id) {
                                if (key == 0)
                                    nextTab = $scope.tabs.select(function (tab, nextKey) {
                                        return nextKey > key && (tab.if == undefined || tab.if) && (tab.privilege == undefined || tab.privilege)
                                    })[0].id;
                                else {
                                    tabs = $scope.tabs.select(function (tab, nextKey) {
                                        return nextKey < key && (tab.if == undefined || tab.if) && (tab.privilege == undefined || tab.privilege)
                                    });
                                    nextTab = tabs[tabs.length - 1].id
                                }
                            }
                        });
                    }

                    //Remove a tab.
                    var tabs = [];
                    angular.forEach($scope.tabs, function (tab) {
                        if (tab.id != id)
                            tabs.push(tab);
                    });
                    $scope.tabs = tabs;

                    //Envia para a próxima caso ela esteja definida.
                    if (nextTab)
                        $scope.activeTab = nextTab;
                };

                this.updateTab = function (id, attrs) {
                    angular.forEach($scope.tabs, function (tab, key) {
                        if (tab.id == id)
                            angular.extend($scope.tabs[key], attrs);
                    })
                };

                this.getTab = function (id) {
                    id = id || $scope.activeTab;

                    var tabs = $.grep($scope.tabs, function (tab) {
                        return tab.id == id;
                    });

                    if(tabs.length == 0)
                        return false;

                    return tabs[0];
                };

                this.reloadTab = function (id) {
                    id = id || $scope.activeTab;

                    $scope.$broadcast('reloadTab', id);
                }
            }],
            link: function (scope, elm, attrs, tabCtrl) {
                scope.tabController = tabCtrl;

                var authObj = {};

                angular.forEach(scope.tabs, function (tab) {
                    if (tab.auth) {
                        if (!authObj[tab.auth.resource]) authObj[tab.auth.resource] = [];

                        if ($.inArray(tab.auth.privilege, authObj[tab.auth.resource]) == -1)
                            authObj[tab.auth.resource].push(tab.auth.privilege);

                        tab.privilege = false;
                    }
                })

                httpService.request({
                    method: "POST",
                    url: pathService.getApiUrl() + "/base/acesso",
                    data: authObj,
                    onSuccess: function (data) {
                        angular.forEach(scope.tabs, function (tab) {
                            if (tab.auth)
                                if (data[tab.auth.resource.replace(/\\/g, '_')])
                                    tab.privilege = data[tab.auth.resource.replace(/\\/g, '_')][tab.auth.privilege];
                        })
                        if (!scope.activeTab) {
                            var tabs = tabCtrl.activeTabs();

                            if (tabs.length)
                                scope.activeTab = tabs[0].id;
                        }
                    }
                })

                var tabs = tabCtrl.activeTabs();

                if (tabs.length)
                    scope.activeTab = tabs[0].id;

                scope.selectTab = function (id) {
                    tabCtrl.selectTab(id);
                }

                scope.closeTab = function (id) {
                    tabCtrl.closeTab(id);
                }

                scope.reloadTab = function (id) {
                    tabCtrl.reloadTab(id);
                }

                scope.$watch('activeTab', function (newVal, oldVal) {
                    if (oldVal != undefined)
                        angular.forEach(scope.tabs, function (tab, key) {
                            if (tab.id == oldVal)
                                scope.tabs[key].active = false
                        })

                    if (newVal != undefined)
                        angular.forEach(scope.tabs, function (tab, key) {
                            if (tab.id == newVal)
                                scope.tabs[key].active = true
                        })
                })
            }
        };
    }])

    .directive('cbkTabsPane', ['$http', '$compile', 'authService', function ($http, $compile, authService) {

        return {
            restrict: 'E',
            require: '^?cbkTabs',
            replace: true,
            scope: {
                tab: '=tabObj'
            },
            template: '<div><div class="tab-pane active" ng-show="tab.active" ng-if="tab.if == undefined || tab.if"></div></div>',
            link: function (scope, elm, attrs, cbkTabsCtrl) {
                var paneScope = scope.$new(true);

                scope.tabController = cbkTabsCtrl;
                scope.tab.nextReload = true;

                var templatePromise = function() {
                    if (scope.tab.url) {
                        return $http.get(scope.tab.url)
                            .then(function(resp) {
                                return resp.data
                            })
                    } else if (scope.tab.template) {
                        return new Promise(function(resolve) {
                            resolve(scope.tab.template)
                        })
                    }
                }

                var loadTab = function (newVal) {
                    if (newVal) {
                        scope.$broadcast('enter');
                        if (scope.tab.nextReload) {
                            templatePromise()
                                .then(function (template) {
                                    paneScope.$destroy();
                                    paneScope = scope.$new(true);

                                    paneScope.tabData = scope.tab.data;
                                    paneScope.tabController = scope.tabController;

                                    elm.find('.tab-pane').html("");
                                    elm.find('.tab-pane').html($compile(template)(paneScope));

                                    try { 
                                        paneScope.$digest()
                                    } catch (e) {
                                    }

                                    scope.tab.nextReload = false;

                                    scope.$broadcast('tabLoaded');
                                })
                        }
                    } else
                        scope.$broadcast('exit')
                };

                if (scope.tab.eager)
                    loadTab(true)

                scope.$watch('tab.active', loadTab);

                var reloadUnregister = scope.$on('reloadTab', function (event, id) {
                    if (id == scope.tab.id) {
                        scope.tab.nextReload = true;
                        loadTab(true);
                    }
                })

                var destroyUnregister = scope.$on('$destroy', function () {
                    reloadUnregister();
                    destroyUnregister();
                    paneScope.$destroy()
                })
            }
        };
    }]);
